import { ShieldCheck, BadgeCheck, Shield, HeartPulse, FileCheck } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, label: "FA Qualified" },
  { icon: BadgeCheck, label: "DBS Checked" },
  { icon: Shield, label: "Safeguarding Trained" },
  { icon: HeartPulse, label: "First Aid Certified" },
  { icon: FileCheck, label: "Fully Insured" },
];

export default function Marquee() {
  const repeated = [...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div data-testid="trust-marquee" className="relative overflow-hidden border-y border-slate-200 bg-slate-50 py-5">
      <div className="flex w-max marquee-track gap-12 px-6">
        {repeated.map((it, i) => {
          const Icon = it.icon;
          return (
            <div key={`${it.label}-${i}`} className="flex items-center gap-3 whitespace-nowrap">
              <Icon className="w-5 h-5 text-[#1E3A8A]" />
              <span className="font-display uppercase tracking-[0.25em] text-sm text-slate-700">{it.label}</span>
              <span className="text-[#1E3A8A]">●</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
